import { Store, Reducer, combineReducers } from 'redux';

type RootStore = Store<{}> & { registeredReducers: { [name: string]: Reducer<{}> } };

export function registerReducer(store: Store<{}>, name: string, reducer: Reducer<{}>): void {
    const rootStore = store as RootStore;
    rootStore.registeredReducers = rootStore.registeredReducers || {};
    rootStore.registeredReducers[name] = reducer;
    store.replaceReducer(createRootReducer(rootStore.registeredReducers));
}

function createRootReducer(reducers?: { [key: string]: Reducer<{}> }): Reducer<{}> {
    return combineReducers<{}>({
        ...reducers,
    });
}
